export default "https://assets.pclncdn.com/web/next-landing/359e71f3fa/_next/static/images/atlanta-91415d66851175129f889d27f9f568a4.jpg";